// The venue's logo URL, picked as TopNavigation does: the navigation logo, else the default one.
// null when the venue has no logo as a URL.
export const venueLogoUrl = (logos) => {
  if (!Array.isArray(logos)) return null
  const logo = logos.find((l) => l.loc === 'navigation') || logos.find((l) => l.loc === 'default')
  return logo && logo.type === 'url' && logo.value ? logo.value : null
}
